import React from "react";
import { graphql } from "gatsby";
import { getImage } from "gatsby-plugin-image";
import "../styles/blog-post.css"; // Import the CSS file

const BlogPost = ({ data }) => {
  const post = data.markdownRemark;
  const image = post.frontmatter.cover
    ? getImage(post.frontmatter.cover)
    : null;

  // Dynamically change the category if it's "pen"
  const category =
    post.frontmatter.category.toLowerCase() === "pen"
      ? "code"
      : post.frontmatter.category;

  // Share URLs
  const shareUrl = typeof window !== "undefined" ? window.location.href : "";
  const blueskyShare = `https://bsky.app/share?text=${encodeURIComponent(
    post.frontmatter.title
  )}&url=${encodeURIComponent(shareUrl)}`;
  const mastodonShare = `https://mastodon.social/share?text=${encodeURIComponent(
    post.frontmatter.title
  )}&url=${encodeURIComponent(shareUrl)}`;

  return (
    <div className="blog-post-container">
      {image && (
        <div
          className="blog-post-cover"
          style={{
            backgroundImage: `url(${post.frontmatter.cover.childImageSharp.gatsbyImageData.images.fallback.src})`,
          }}
        >
          <h1 className="blog-post-title">{post.frontmatter.title}</h1>
        </div>
      )}
      <div className="blog-post-category-info">
        <div className="category-container">
          <span className="category-label">Category:</span>
          <span className="category-value">{category}</span>
        </div>
        <div className="share-icons-container">
          <a
            href={blueskyShare}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/icons/bluesky-icon.png"
              alt="Bluesky"
              className="share-icon"
            />
          </a>
          <a
            href={mastodonShare}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/icons/mastodon-icon.png"
              alt="Mastodon"
              className="share-icon"
            />
          </a>
        </div>
      </div>
      <div
        className="blog-post-content"
        dangerouslySetInnerHTML={{ __html: post.html }}
      />
    </div>
  );
};

export const query = graphql`
  query BlogPostQuery($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        category
        cover {
          childImageSharp {
            gatsbyImageData(width: 800, layout: CONSTRAINED)
          }
        }
      }
      html
    }
  }
`;

export default BlogPost;
